export default __webpack_public_path__ + "static/media/model-papers.eec15c0a.svg";